/**
 * Malcriados · landings (Regalo5 y Memorial).
 *
 * 1. Elegir la prenda: cambia la galeria, las miniaturas y el boton de compra.
 *    Avisa con el evento "mc:prenda" ({ indice, opcion }) para quien lo necesite.
 * 2. Barra fija: muestra el precio mas bajo de las prendas de la pagina.
 * 3. Menu del encabezado propio (Memorial, celular).
 *
 * Todo por delegacion en document: sigue funcionando si el editor de temas
 * vuelve a pintar una seccion.
 */

/** @param {Element} raiz @param {number} indice @param {number} vista */
function mostrarVista(raiz, indice, vista) {
  for (const nodo of raiz.querySelectorAll('[data-el-vista]')) {
    const activa = nodo.getAttribute('data-el-vista') === `${indice}-${vista}`;
    nodo.toggleAttribute('hidden', !activa);
    nodo.classList.toggle('mc-entra', activa);
  }
  for (const grupo of raiz.querySelectorAll('[data-el-minis]')) {
    const delGrupo = grupo.getAttribute('data-el-minis') === String(indice);
    grupo.toggleAttribute('hidden', !delGrupo);
    if (!delGrupo) continue;
    for (const mini of grupo.querySelectorAll('[data-el-mini]')) {
      mini.setAttribute('aria-pressed', String(mini.getAttribute('data-el-mini') === String(vista)));
    }
  }
}

/** @param {Element} raiz @param {HTMLElement} opcion */
function elegirPrenda(raiz, opcion) {
  const indice = Number(opcion.getAttribute('data-el-opcion'));
  for (const otra of raiz.querySelectorAll('[data-el-opcion]')) {
    otra.setAttribute('aria-pressed', String(otra === opcion));
  }
  mostrarVista(raiz, indice, 0);

  const boton = raiz.querySelector('[data-el-cta]');
  if (boton) {
    boton.setAttribute('href', opcion.getAttribute('data-el-url') || '#');
    const texto = boton.querySelector('[data-el-cta-texto]');
    if (texto) texto.textContent = opcion.getAttribute('data-el-boton') || '';
  }
  raiz.dispatchEvent(new CustomEvent('mc:prenda', { bubbles: true, detail: { indice, opcion } }));
}

/** @param {number} centavos */
function dinero(centavos) {
  const pesos = String(Math.round(centavos / 100));
  return `$${pesos.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
}

function pintarPrecioMinimo() {
  const destinos = document.querySelectorAll('[data-mc-fija-desde]');
  if (!destinos.length) return;
  let minimo = Infinity;
  for (const opcion of document.querySelectorAll('[data-el-precio]')) {
    const precio = Number(opcion.getAttribute('data-el-precio'));
    if (precio > 0 && precio < minimo) minimo = precio;
  }
  if (minimo === Infinity) return;
  for (const destino of destinos) {
    const plantilla = destino.getAttribute('data-mc-fija-desde') || '[precio]';
    destino.textContent = plantilla.replace('[precio]', dinero(minimo));
    destino.removeAttribute('hidden');
  }
}

/** @param {Element} menu @param {boolean} abierto */
function fijarMenu(menu, abierto) {
  const boton = menu.querySelector('[data-mc-menu-boton]');
  const panel = menu.querySelector('[data-mc-menu-panel]');
  boton?.setAttribute('aria-expanded', String(abierto));
  panel?.toggleAttribute('hidden', !abierto);
  panel?.classList.toggle('mc-entra', abierto);
}

document.addEventListener('click', (evento) => {
  const origen = evento.target instanceof Element ? evento.target : null;
  if (!origen) return;

  const opcion = origen.closest('[data-el-opcion]');
  if (opcion instanceof HTMLElement) {
    const raiz = opcion.closest('[data-mc-elegir]');
    if (raiz) elegirPrenda(raiz, opcion);
    return;
  }

  const mini = origen.closest('[data-el-mini]');
  if (mini) {
    const raiz = mini.closest('[data-mc-elegir]');
    const grupo = mini.closest('[data-el-minis]');
    if (raiz && grupo) {
      mostrarVista(raiz, Number(grupo.getAttribute('data-el-minis')), Number(mini.getAttribute('data-el-mini')));
    }
    return;
  }

  const botonMenu = origen.closest('[data-mc-menu-boton]');
  if (botonMenu) {
    const menu = botonMenu.closest('[data-mc-menu]');
    if (menu) fijarMenu(menu, botonMenu.getAttribute('aria-expanded') !== 'true');
    return;
  }

  /* Tocar un enlace del menu, o fuera de el, lo cierra. */
  for (const menu of document.querySelectorAll('[data-mc-menu]')) {
    const abierto = menu.querySelector('[data-mc-menu-boton]')?.getAttribute('aria-expanded') === 'true';
    if (abierto && (!menu.contains(origen) || origen.closest('a'))) fijarMenu(menu, false);
  }
});

document.addEventListener('keydown', (evento) => {
  if (evento.key !== 'Escape') return;
  for (const menu of document.querySelectorAll('[data-mc-menu]')) fijarMenu(menu, false);
});

pintarPrecioMinimo();
document.addEventListener('shopify:section:load', pintarPrecioMinimo);

/**
 * Barra fija inferior: si la pagina tiene un boton de portada marcado con [data-mc-boton-heroe],
 * la barra aparece solo cuando ese boton ya quedo arriba (se paso hacia abajo), igual que la
 * barra de compra de la ficha de producto. Sin JS la barra se ve siempre.
 */
let observadorBarra = null;
function iniciarBarraFija() {
  if (observadorBarra) observadorBarra.disconnect();
  observadorBarra = null;
  const boton = document.querySelector('[data-mc-boton-heroe]');
  const barras = [...document.querySelectorAll('.shopify-section:has(> .mc-fija)')];
  if (!boton || !barras.length || !('IntersectionObserver' in window)) return;
  for (const barra of barras) barra.style.display = 'none';
  observadorBarra = new IntersectionObserver((entradas) => {
    for (const entrada of entradas) {
      const pasado = !entrada.isIntersecting && entrada.boundingClientRect.top < 0;
      for (const barra of barras) barra.style.display = pasado ? '' : 'none';
    }
  });
  observadorBarra.observe(boton);
}

iniciarBarraFija();
document.addEventListener('shopify:section:load', iniciarBarraFija);
